module.exports = __webpack_public_path__ + "slide11.18219c53cb82530b478d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide11.jpg
// module id = ./src/assets/images/private/home/slide11.jpg
// module chunks = main